// extracted by css-extract-rspack-plugin
export default {"container":"container-UZWLpk","tooltipContent":"tooltipContent-Wnh8UQ","tooltip":"tooltip-NEZNwi"};